import React from 'react'
import { WMSTileLayer } from 'react-leaflet'

function EcuadorConflictosUsoLayer({ opacity = 0.6 }) {
  return (
    <WMSTileLayer
      layers="vw_em000_conflictos_uso_tierras"
      format="image/png"
      version="1.1.1"
      transparent
      tiled
      url={`https://g8a078u1g6.execute-api.eu-west-1.amazonaws.com/app/wms-ecuador/fisiografia/E25k/wms`}
      opacity={opacity}
    />
  )
}

export default EcuadorConflictosUsoLayer
